<template>
  <div>
    <el-form-item label="File" v-if="filelist.length > 1">

      <el-select v-if="filelist.length > 1" v-model="selection" placeholder="Please select" size="small"
        @change="update_pdf">
        <el-option v-for="item in filelist" :key="item.url" :label="item.label" :value="item.value.id" />
      </el-select>
    </el-form-item>
    <div style="width:900px !important;margin: 0 auto; position: relative; min-height: 400px;">

      <div v-if="isLoading" class="pdf-loader">
        <el-icon class="is-loading" :size="40">
          <Loading />
        </el-icon>
        <p>Loading PDF...</p>
      </div>

      <div v-if="!isLoading && pageCount > 0">
        <VuePdf :src="arr_int8" v-for="i in pageCount" :key="i" :page="i"></VuePdf>
      </div>

    </div>
  </div>
</template>


<script>
import { Loading } from '@element-plus/icons-vue';
import { computed, ref, watch } from 'vue';
import { VuePdf, createLoadingTask } from 'vue3-pdfjs/esm';
import { apiHelpers } from "../helpers";
import { messages } from '../popups.js';
export default {
  name: "PDFJsView",
  components: { VuePdf, Loading },
  setup() {
    const { showerorr, notify } = messages()
    const isLoading = ref(false)

    const filelist = computed(() => {
      return store.getters['api/filelist'].map(f => { return { label: f.docfile.split("/").at(-1), value: { url: f.docfile, id: f.id } } })
    });
    let pageCount = ref(0)
    let currentPage = ref(1)
    let loadingTask = ref({})
    let arr_int8 = ref(new Uint8Array())
    let file = ref("")
    const { store } = apiHelpers();
    const selection = ref(null)

    const get_url = (id) => {
      if (store.state.api.filelist.length > 0) {
        if (id) {
          const match = store.state.api.filelist.find(item => item.id === id)
          return match ? match.docfile : store.state.api.filelist[0].docfile
        } else {
          return store.state.api.filelist[0].docfile
        }

        //
      } else {
        return null
      }
    }

    const update_pdf = async (value) => {
      console.log("---------------------------")
      console.log(value)
      console.log(selection.value)
      isLoading.value = true
      store.dispatch('api/after_edit', { field: 'pdf_file', value: value, grid: null, row: -1, view: 'record_details' })
        .then(() => { })
        .catch(err => {
          showerorr(err)
        })
      arr_int8.value = null
      pageCount.value = 0
      loadfile(get_url(value))
    }
    const loadfile = async (url) => {
      if (url == null) {
        isLoading.value = false
        return
      }
      isLoading.value = true
      arr_int8.value = null
      pageCount.value = 0
      await store.dispatch('api/filedownload', { url: url, display: true })
        .then((response) => {
          if (response != null) {
            response.arrayBuffer()
              .then((buf) => {
                let uint8View = new Uint8Array(buf);


                loadingTask.value = createLoadingTask(uint8View);
                loadingTask.value.promise.then(pdf => {
                  pageCount.value = pdf.numPages;
                  arr_int8.value = uint8View
                  isLoading.value = false
                });


              })
          } else {
            isLoading.value = false
          }
        })
        .catch(() => {
          notify('warning', "Could no load PDF")
          isLoading.value = false
        })
    }
    watch(filelist, async (currentValue, oldValue) => {
      // Compare array contents, not references
      const currentIds = currentValue.map(f => f.value.id).join(',')
      const oldIds = (oldValue || []).map(f => f.value.id).join(',')
      if (currentIds === oldIds) {
        return
      }
      isLoading.value = true
      arr_int8.value = null
      pageCount.value = 0
      file.value = currentValue

      const pdfId = store.state.api.record_details.pdf_file
      const match = store.state.api.filelist.find(item => item.id === pdfId)
      selection.value = match ? pdfId : (store.state.api.filelist[0] && store.state.api.filelist[0].id)
      await loadfile(get_url(pdfId));


    });

    return {
      loadingTask, pageCount, currentPage, selection, filelist, update_pdf, arr_int8, file, isLoading
    }
  }

};
</script>

<style scoped>
.pdf-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 16px;
}

.pdf-loader p {
  color: #606266;
  font-size: 14px;
  margin: 0;
}

.is-loading {
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
